import { UserRole } from '~/types/user'

export function useTelemedicineNav() {
    const auth = useAuthStore()
    return computed(() => {
        if (auth.hasRole(UserRole.telemedicineDoctor)) {
            return [
                { label: 'Overview', to: '/telemedicine', icon: 'i-ph-house-line-duotone', exact: true },
                { label: 'Schedule', to: '/telemedicine/schedule', icon: 'i-ph-calendar-dots-duotone' },
                { label: 'My profile', to: '/telemedicine/profile', icon: 'i-ph-identification-card-duotone' },
            ]
        }
        return [
            { label: 'Overview', to: '/telemedicine', icon: 'i-ph-house-line-duotone', exact: true },
            { label: 'Doctors', to: '/telemedicine/doctors', icon: 'i-ph-stethoscope-duotone' },
            { label: 'Specialties', to: '/telemedicine/specialties', icon: 'i-ph-list-bullets-duotone' },
        ]
    })
}
